/* Adapt legacy rich-text layouts without replacing copy, prices or colour assets. */
(function () {
  'use strict';
  function text(node) { return (node.textContent || '').replace(/\s+/g, ' ').trim(); }
  function empty(node) { return !text(node) && !node.querySelector('img,iframe,video,input,button'); }
  var paintFeatureProfiles = {
    'r-one-color-selection': {
      eyebrow: 'R.ONE',
      heading: 'Paint + primer made for everyday living.',
      copy: 'A versatile interior finish with low odour, strong coverage and easy-care durability.',
      priorities: [/built-in primer/i, /low voc|anti-smell/i, /washability|wear resistance/i, /hiding power|coverage/i, /fungus|mould/i, /colour retention/i]
    },
    'r-one-antimould-color-selection': {
      eyebrow: 'R.ONE ANTIMOULD+',
      heading: 'Paint + primer with mould and bacteria protection.',
      copy: 'A near-odourless interior finish combining self-priming performance with washable, long-term surface protection.',
      priorities: [/paint & primer|2-in-1/i, /mould.*bacteria|anti-mould.*anti-bacterial/i, /near.*odour|zero voc/i, /hiding power|coverage/i, /washability|washable/i, /water-based|non-toxic/i]
    },
    'r-one-x-colour-selection': {
      eyebrow: 'R.ONE X',
      heading: 'Extra durability for hardworking spaces.',
      copy: 'A premium interior paint + primer with enhanced washability, water resistance and lasting protection.',
      priorities: [/paint & primer/i, /durability/i, /washability|scrub resistance/i, /water resistance/i, /anti-bacterial/i, /hiding power|coverage/i]
    },
    'r-wash-color-selection': {
      eyebrow: 'R.WASH',
      heading: 'Washable walls for everyday living.',
      copy: 'An easy-care interior finish designed for regular cleaning, dependable coverage and comfortable spaces.',
      priorities: [/premium interior washable/i, /washability|wear resistance/i, /hiding power|coverage/i, /fungus|mould/i, /low voc|anti-smell/i, /colour retention/i]
    },
    'r-coat-color-selection': {
      eyebrow: 'R.COAT',
      heading: 'Reliable coverage with a clean matt finish.',
      copy: 'A practical interior coating with low odour, smooth application and dependable everyday durability.',
      priorities: [/hiding power|coverage/i, /durable/i, /paint flow|brush marks/i, /mould|fungus/i, /low voc|anti-smell/i, /smooth matt finish/i]
    },
    'r-antismell-color-selection': {
      eyebrow: 'R.ANTISMELL',
      heading: 'Fresh-feeling rooms with near-zero paint odour.',
      copy: 'A low-VOC interior finish that combines comfortable application with strong coverage and a smooth matt look.',
      priorities: [/anti-smell|low voc/i, /hiding power|coverage/i, /smooth matt finish/i, /durable/i, /colour retention/i, /paint flow|brush mark/i]
    },
    'r-airpurify-color-selection-apply-rp10-for-10-off': {
      eyebrow: 'R.AIRPURIFY',
      heading: 'Cleaner-feeling air for more comfortable rooms.',
      copy: 'A nearly odourless, zero-VOC finish with formaldehyde-reduction, antibacterial and easy-care benefits.',
      priorities: [/formaldehyde reduction/i, /zero voc|odorless|odourless/i, /asthma|allergy/i, /anti-mould|antibacterial/i, /coverage/i, /washability/i]
    },
    'r-antivirus': {
      eyebrow: 'R.ANTIVIRUS',
      heading: 'Targeted surface protection for high-contact spaces.',
      copy: 'A tested antiviral and antibacterial coating with strong washability, coverage and multi-surface use.',
      priorities: [/anti-coronavirus/i, /antibacterial protection/i, /first anti-viral paint/i, /washability|wear resistant/i, /multiple substrate|walls & ceiling/i, /hiding power|coverage/i]
    },
    'r-baby': {
      eyebrow: 'R.BABY',
      heading: 'A gentler choice for nurseries and family spaces.',
      copy: 'A baby-safe, odour-free paint + primer with air-purifying, antibacterial and easy-care performance.',
      priorities: [/baby-safe|odour-free/i, /air-purifying/i, /harmful air pollutants/i, /antibacterial/i, /washability|wear resistant/i, /zero voc|near zero odour/i]
    },
    'r-weather-color-selection': {
      eyebrow: 'R.WEATHER',
      heading: 'Long-lasting protection against changing weather.',
      copy: 'A durable exterior coating with UV protection, strong resistance and lasting colour performance.',
      priorities: [/weather effects/i, /uv protection/i, /dirt, water|resistance to dirt/i, /washability|anti-stain/i, /adhesion/i, /fungus|mould/i]
    },
    'r-one-exterior-color-selection': {
      eyebrow: 'R.ONE EXTERIOR',
      heading: 'Paint + primer built for exterior protection.',
      copy: 'A low-odour 2-in-1 coating with weather resistance, strong coverage and long-lasting colour.',
      priorities: [/paint & primer 2-in-1/i, /weather resistant/i, /hiding power/i, /water resistant/i, /washability|wear resistant/i, /colour retention|fade resistant/i]
    },
    'r-aqua-color-selection': {
      eyebrow: 'R.AQUA',
      heading: 'Water-based enamel for wood and metal.',
      copy: 'A low-odour paint + primer for doors, gates and metalwork with strong adhesion and weather resistance.',
      priorities: [/paint & primer 2-in-1 water-based enamel/i, /wood & metal paint/i, /adhesion/i, /weather resistant|water resistant/i, /anti-rust|anti-tannins/i, /near zero paint odour/i]
    },
    'r-antimould-matt': {
      eyebrow: 'R.ANTIMOULD MATT',
      heading: 'True-matt protection for humid interior spaces.',
      copy: 'A protective interior coating designed for high-humidity and sensitive areas, with anti-mould and antibacterial performance.',
      priorities: [/anti-mould|mould/i, /anti-bacterial|antibacterial/i, /true matt|matt/i, /humidity|moisture/i, /coverage|hiding power/i, /low voc|odour/i]
    },
    'r-antimould': {
      eyebrow: 'R.ANTIMOULD',
      heading: 'Focused protection for damp-prone ceilings and rooms.',
      copy: 'A 2-in-1 interior paint and primer developed for kitchens, bathrooms, ceilings and other mould-prone areas.',
      priorities: [/paint & primer|2-in-1/i, /mould|fungus/i, /anti-bacterial|antibacterial/i, /water resistance/i, /hiding power|coverage/i, /low voc|odour/i]
    },
    'r-limewash-collection': {
      eyebrow: 'R.LIMEWASH',
      heading: 'Natural depth with a breathable mineral finish.',
      copy: 'A traditional lime-based decorative coating that creates soft tonal movement, texture and timeless character on prepared walls.',
      priorities: [/breathability|breathable/i, /non-toxic|eco-friendly|solvent-free/i, /natural|lime/i, /mould|alkaline/i, /texture|velvety/i, /low voc|odour/i]
    },
    'r-weatherflex-color-selection-apply-rp10-for-10-off-copy': {
      eyebrow: 'R.WOOD',
      heading: 'Durable protection that keeps the wood grain visible.',
      copy: 'A quick-drying water-based polyurethane finish for prepared decking, floors, doors and furniture indoors or outdoors.',
      priorities: [/polyurethane|water-based/i, /wood grain|stain/i, /durability|durable/i, /water resistance|weather/i, /quick dry|drying/i, /coverage/i]
    }
  };
  function paintFeatureProfile() {
    var match = location.pathname.match(/\/collections\/([^/]+)/i);
    if (match && paintFeatureProfiles[match[1].toLowerCase()]) return paintFeatureProfiles[match[1].toLowerCase()];

    var pageTitle = document.title || '';
    var titleProfiles = [
      { pattern: /r\.one\s+antimould\+/i, key: 'r-one-antimould-color-selection' },
      { pattern: /r\.antimould\s+matt/i, key: 'r-antimould-matt' },
      { pattern: /r\.one\s+exterior/i, key: 'r-one-exterior-color-selection' },
      { pattern: /r\.one\s+x/i, key: 'r-one-x-colour-selection' },
      { pattern: /r\.baby/i, key: 'r-baby' },
      { pattern: /r\.airpurify/i, key: 'r-airpurify-color-selection-apply-rp10-for-10-off' },
      { pattern: /r\.antivirus/i, key: 'r-antivirus' },
      { pattern: /r\.antismell/i, key: 'r-antismell-color-selection' },
      { pattern: /r\.wash/i, key: 'r-wash-color-selection' },
      { pattern: /r\.coat/i, key: 'r-coat-color-selection' },
      { pattern: /r\.aqua/i, key: 'r-aqua-color-selection' },
      { pattern: /r\.limewash/i, key: 'r-limewash-collection' },
      { pattern: /r\.wood/i, key: 'r-weatherflex-color-selection-apply-rp10-for-10-off-copy' },
      { pattern: /r\.antimould/i, key: 'r-antimould' },
      { pattern: /r\.one/i, key: 'r-one-color-selection' }
    ];
    var titleMatch = titleProfiles.find(function (candidate) { return candidate.pattern.test(pageTitle); });
    if (titleMatch) return paintFeatureProfiles[titleMatch.key];

    return {
      eyebrow: 'PRODUCT FEATURES',
      heading: 'Performance details at a glance.',
      copy: 'Review the listed benefits and finish characteristics to help choose the right paint for your project.',
      priorities: []
    };
  }
  var paintFeaturePresentations = [
    { pattern: /paint\s*&\s*primer|paint\s*\+\s*primer|primer\s*2-in-1|2-in-1.*primer/i, title: 'Paint + primer', copy: 'Built-in primer supports an even, durable finish.' },
    { pattern: /anti[- ]?coronavirus|anti[- ]?viral|antiviral/i, title: 'Antiviral protection', copy: 'Targeted protection for frequently used interior spaces.' },
    { pattern: /formaldehyde reduction/i, title: 'Formaldehyde reduction', copy: 'Helps reduce airborne formaldehyde in interior spaces.' },
    { pattern: /baby[- ]?safe|odour[- ]?free/i, title: 'Family-friendly formula', copy: 'Low-odour performance for nurseries and family rooms.' },
    { pattern: /air[- ]?purifying/i, title: 'Air-purifying performance', copy: 'Supports cleaner-feeling air in occupied rooms.' },
    { pattern: /harmful air pollutants/i, title: 'Indoor air support', copy: 'Helps address selected airborne pollutants indoors.' },
    { pattern: /asthma|allergy/i, title: 'Comfort-conscious choice', copy: 'A considered finish for sensitive family spaces.' },
    { pattern: /eco[- ]?friendly|non[- ]?toxic/i, title: 'Eco-friendly formula', copy: 'A water-based, non-toxic choice for interior spaces.' },
    { pattern: /zero voc|low voc|anti[- ]?smell|near zero.*odou?r|odou?rless/i, title: 'Near odourless', copy: 'Comfortable to apply in occupied interior spaces.' },
    { pattern: /anti[- ]?mould.*anti[- ]?bacterial|anti[- ]?bacterial.*anti[- ]?mould/i, title: 'Mould + bacteria protection', copy: 'Added protection against mould, fungus and bacteria.' },
    { pattern: /anti[- ]?bacterial/i, title: 'Antibacterial protection', copy: 'Added protection for cleaner interior surfaces.' },
    { pattern: /mould|fungus/i, title: 'Mould-resistant finish', copy: 'Helps resist mould and fungal growth on the finish.' },
    { pattern: /washability|washable|scrub resistance|wear resistance/i, title: 'Washable finish', copy: 'Made for regular cleaning and everyday wear.' },
    { pattern: /water resistance|water resistant/i, title: 'Water resistance', copy: 'Helps the finish withstand routine moisture exposure.' },
    { pattern: /weather effects|weather resistant/i, title: 'Weather protection', copy: 'Designed to perform through changing exterior weather conditions.' },
    { pattern: /uv protection/i, title: 'UV protection', copy: 'Helps protect exterior colour and finish from prolonged sun exposure.' },
    { pattern: /resistance to dirt|dirt,\s*water|anti[- ]?stain/i, title: 'Dirt + stain resistance', copy: 'Helps exterior surfaces stay cleaner and easier to maintain.' },
    { pattern: /wood\s*&\s*metal|wood and metal/i, title: 'Wood + metal use', copy: 'A versatile finish for suitable timber and metal surfaces.' },
    { pattern: /anti[- ]?rust|anti[- ]?tannins/i, title: 'Surface protection', copy: 'Helps guard suitable substrates against rust or tannin-related staining.' },
    { pattern: /adhesion/i, title: 'Strong adhesion', copy: 'Designed to bond reliably to correctly prepared surfaces.' },
    { pattern: /multiple substrate|walls\s*&\s*ceiling/i, title: 'Multi-surface use', copy: 'Suitable for a range of correctly prepared walls and ceiling surfaces.' },
    { pattern: /hiding power|coverage/i, title: 'Strong coverage', copy: 'Excellent hiding power supports a consistent finish.' },
    { pattern: /colour retention|fade resistant/i, title: 'Colour retention', copy: 'Helps colour maintain a fresh, consistent appearance.' },
    { pattern: /smooth matt|matt finish/i, title: 'Smooth matt finish', copy: 'Creates an even surface with a refined low-sheen look.' },
    { pattern: /paint flow|brush mark/i, title: 'Smooth application', copy: 'Balanced flow helps reduce visible brush marks during application.' },
    { pattern: /durability|durable|long[- ]?lasting/i, title: 'Long-lasting durability', copy: 'Maintains a dependable finish through everyday use.' }
  ];
  function addFeaturePresentation(item) {
    if (!item || item.dataset.rpFeaturePresentationReady) return;
    var original = text(item).replace(/^[\u2713\u2714]\s*/, '');
    var presentation = paintFeaturePresentations.find(function (candidate) { return candidate.pattern.test(original); });
    if (!presentation) {
      presentation = {
        title: original,
        copy: 'Supports dependable performance and a consistent painted finish.'
      };
    }
    item.textContent = '';
    var title = document.createElement('strong');
    title.className = 'rp-feature-title';
    title.textContent = presentation.title;
    var copy = document.createElement('p');
    copy.className = 'rp-feature-copy';
    copy.textContent = presentation.copy;
    item.appendChild(title);
    item.appendChild(copy);
    item.dataset.rpFeaturePresentationReady = 'true';
  }
  function prioritiseFeatureItems(list, items, priorities) {
    var chosen = [];
    priorities.forEach(function (pattern) {
      var match = items.find(function (item) { return chosen.indexOf(item) === -1 && pattern.test(text(item)); });
      if (match) chosen.push(match);
    });
    items.forEach(function (item) { if (chosen.indexOf(item) === -1) chosen.push(item); });
    chosen.forEach(function (item) { list.appendChild(item); });
    return chosen;
  }
  function addFeatureIntroduction(section, profile) {
    if (!profile || section.querySelector('.rp-feature-intro')) return;
    var oldHeading = Array.from(section.children).find(function (child) { return child.classList.contains('rp-info-heading'); });
    var intro = document.createElement('div'); intro.className = 'rp-feature-intro';
    var eyebrow = document.createElement('p'); eyebrow.className = 'rp-feature-intro__eyebrow'; eyebrow.textContent = profile.eyebrow;
    var heading = document.createElement('h2'); heading.className = 'rp-feature-intro__heading'; heading.textContent = profile.heading;
    var copy = document.createElement('p'); copy.className = 'rp-feature-intro__copy'; copy.textContent = profile.copy;
    intro.appendChild(eyebrow); intro.appendChild(heading); intro.appendChild(copy);
    if (oldHeading) oldHeading.replaceWith(intro);
    else section.prepend(intro);
  }
  function addFeatureListLabel(list) {
    if (!list || list.previousElementSibling && list.previousElementSibling.classList.contains('rp-feature-list-label')) return;
    var label = document.createElement('p');
    label.className = 'rp-feature-list-label';
    label.textContent = 'Key features';
    list.before(label);
  }
  function readingNodes(nodes) {
    var result = [];
    nodes.forEach(function (node) {
      // Unwrap layout-only containers, never images, specifications or form controls.
      if (node.nodeType === 1 && node.matches('div') && node.querySelector('h1,h2,h3,h4,ul,ol,p') && !node.querySelector('img,table,iframe,video,form,input')) {
        result = result.concat(readingNodes(Array.from(node.childNodes)));
      } else result.push(node);
    });
    return result;
  }
  function sectionsFromNodes(nodes, flow) {
    var article = document.createElement('section'); article.className = 'rp-info-section';
    flow.appendChild(article);
    readingNodes(nodes).forEach(function (node) {
      if (node.nodeType === 3 && /^\s*application(?:\s|:)/i.test(node.textContent)) {
        var heading = document.createElement('p'); node.parentNode && node.parentNode.insertBefore(heading, node); heading.appendChild(node); node = heading;
      }
      if (node.nodeType === 1) {
        var label = text(node);
        var isHeading = label.length < 100 && (/^(features(?:\s|:|$)|application(?:\s|:|$)|packaging|technical information|how to apply)/i.test(label) || node.matches('h2,h3'));
        if (isHeading) {
          if (text(article) || article.querySelector('img')) { article = document.createElement('section'); article.className = 'rp-info-section'; flow.appendChild(article); }
          node.classList.add('rp-info-heading');
          if (/^features/i.test(label)) article.classList.add('rp-info-section--features');
          if (/^application|how to apply/i.test(label)) article.classList.add('rp-info-section--application');
        }
      }
      article.appendChild(node);
    });
    if (!text(article) && !article.querySelector('img,iframe,video')) article.classList.add('rp-empty-spacer');
  }
  function refineRange(content, hero) {
    content.classList.add('rp-range-landing');
    if (hero) {
      content.prepend(hero); // Every range starts with its hero, including nested legacy pages.
      var copy = hero.querySelector('.rp-range-hero__copy');
      var actions = document.createElement('div'); actions.className = 'rp-range-actions';
      var prices = [];
      Array.from(copy.children).forEach(function (node) {
        if (node.classList.contains('rp-range-hero__title') || node.classList.contains('rp-empty-spacer')) return;
        if (node.querySelector('.rp-page-cta')) {
          Array.from(node.querySelectorAll('.rp-page-cta')).forEach(function (link) { actions.appendChild(link); });
          if (!text(node) && !node.querySelector('img')) node.remove();
          return;
        }
        var replacement = node;
        if (node.matches('h1,h2,h3')) {
          replacement = document.createElement('p');
          while (node.firstChild) replacement.appendChild(node.firstChild);
          node.replaceWith(replacement);
        }
        if (/\$/.test(text(replacement))) { replacement.classList.add('rp-range-price'); prices.push(replacement); }
        else replacement.classList.add('rp-range-subtitle');
      });
      copy.appendChild(actions);
      prices.forEach(function (price) { copy.appendChild(price); });
      var primary = actions.querySelector('a');
      if (primary) {
        var relative = new URL(primary.href, location.href);
        // Keep navigation inside the draft preview for internal range links.
        if (relative.hostname === 'www.rafflespaint.com' || relative.hostname === 'rafflespaint.com') primary.href = relative.pathname + relative.search + relative.hash;
      }
    }
    var details = document.createElement('section'); details.className = 'rp-range-details';
    var specs = document.createElement('aside'); specs.className = 'rp-range-specs';
    var specList = document.createElement('ul'); specList.className = 'rp-range-spec-list';
    var documents = document.createElement('ul'); documents.className = 'rp-range-documents';
    content.querySelectorAll('.rp-info-section li').forEach(function (item) {
      var label = text(item);
      if (item.querySelector('a') && /^(technical data sheet|safety data sheet)$/i.test(label)) documents.appendChild(item);
      else if (/^(sizes?\s*:|approx\.?\s*coverage|coverage\s*:|fully cured\s*:|touch-dry\s*:|recoat\s*:|packaging\s*:)/i.test(label)) specList.appendChild(item);
    });
    var application = content.querySelector('.rp-info-section--application');
    content.querySelectorAll('.rp-info-section--features').forEach(function (section) {
      section.classList.add('rp-range-features');
      var heading = section.querySelector('.rp-info-heading');
      var body = document.createElement('div'); body.className = 'rp-range-feature-body';
      Array.from(section.childNodes).forEach(function (node) { if (node !== heading) body.appendChild(node); });
      section.appendChild(body);
      // Documents moved out of feature cards do not leave blank rows.
      body.querySelectorAll('ul').forEach(function (list) { if (!text(list)) list.classList.add('rp-empty-spacer'); });
      body.querySelectorAll('li').forEach(function (item) { if (/^[✓✔]/.test(text(item))) item.classList.add('rp-feature-has-check'); });
    });
    if (application || specList.children.length || documents.children.length) {
      if (application) { application.classList.add('rp-range-application'); details.appendChild(application); }
      if (specList.children.length || documents.children.length) {
        var title = document.createElement('h3'); title.textContent = 'Product details'; specs.appendChild(title);
        if (specList.children.length) specs.appendChild(specList);
        if (documents.children.length) specs.appendChild(documents);
        details.appendChild(specs);
      }
      if (details.children.length === 1) details.classList.add('rp-range-details--single');
      content.appendChild(details);
      details.id = 'PaintRangeDetails';
      if (hero && primary) {
        var detailLink = document.createElement('a'); detailLink.href = '#PaintRangeDetails'; detailLink.className = 'rp-range-detail-link'; detailLink.textContent = 'View product details'; actions.appendChild(detailLink);
      }
    }
    var preview = content.querySelector('.rp-range-colour-preview');
    if (preview && hero) hero.after(preview);
    content.querySelectorAll('.rp-info-section').forEach(function (section) {
      if (!text(section) && !section.querySelector('img,iframe,video')) section.classList.add('rp-empty-spacer');
    });
    if (hero && primary) {
      var closing = document.createElement('section'); closing.className = 'rp-range-final-action';
      var closingTitle = document.createElement('h2'); closingTitle.textContent = 'Ready to choose your paint?';
      var closingActions = document.createElement('div'); closingActions.className = 'rp-range-actions';
      closingActions.appendChild(primary.cloneNode(true));
      var service = document.createElement('a'); service.href = '/pages/professional-painting-service'; service.className = 'rp-range-detail-link'; service.textContent = 'Painting service';
      closingActions.appendChild(service); closing.appendChild(closingTitle); closing.appendChild(closingActions); content.appendChild(closing);
    }
  }
  function enhanceOptionLabels(meta) {
    meta.querySelectorAll('#bcpo .bcpo-image-parent').forEach(function (card) {
      var input = card.querySelector('input[type="radio"]');
      var label = card.querySelector('.bcpo-front-image-label');
      if (!input || !label || label.dataset.rpOptionLabel) return;
      // Keep full option wording in its native value, accessible name and selected summary.
      // Long accessory notes belong in that summary, not a tiny sample-card caption.
      var caption = input.value.length > 36 ? input.value.replace(/\s*\([^)]*\)\s*$/, '').trim() : input.value;
      label.dataset.rpOptionLabel = caption || input.value;
      if (label.dataset.rpOptionLabel.length > 36) label.dataset.rpLongLabel = 'true';
      label.setAttribute('title', input.value);
      input.setAttribute('aria-label', input.value);
    });
    meta.querySelectorAll('#bcpo .single-option-selector.bcpo-images').forEach(function (options) {
      var cards = Array.from(options.querySelectorAll('.bcpo-image-parent'));
      if (cards.length < 9 || options.dataset.rpSearchBound) return;
      options.dataset.rpSearchBound = 'true';
      var label = document.createElement('label'); label.className = 'rp-option-search-label'; label.textContent = 'Search colour names';
      var search = document.createElement('input'); search.type = 'search'; search.className = 'rp-option-search'; search.placeholder = 'Enter a colour name';
      search.id = 'PaintOptionSearch-' + Math.random().toString(36).slice(2, 8); label.htmlFor = search.id;
      var status = document.createElement('p'); status.className = 'rp-option-search-status'; status.setAttribute('aria-live', 'polite');
      options.before(label, search, status);
      search.addEventListener('input', function () {
        var query = search.value.trim().toLowerCase(), visible = 0;
        cards.forEach(function (card) {
          var radio = card.querySelector('input[type="radio"]');
          card.hidden = !!query && (!radio || radio.value.toLowerCase().indexOf(query) === -1);
          if (!card.hidden) visible++;
        });
        status.textContent = visible + ' matching options. Your selected colour is unchanged.';
      });
    });
  }
  function enhance(root) {
    root.querySelectorAll('.rp-editorial-content').forEach(function (content) {
      if (content.dataset.rpLayoutReady) return;
      content.dataset.rpLayoutReady = 'true';
      var page = content.closest('[data-page-handle]');
      var handle = page ? page.dataset.pageHandle : '';
      Array.from(content.children).forEach(function (node) {
        if (empty(node)) node.classList.add('rp-empty-spacer');
      });
      content.querySelectorAll('h1 a,h2 a,h3 a').forEach(function (link) {
        if (/^(buy|learn more|shop|select|order|get (a )?quote)/i.test(text(link))) {
          link.classList.add('rp-page-cta');
          link.closest('h1,h2,h3').classList.add('rp-cta-row');
        }
      });
      if (['copy-of-interior-paints','exterior-paints','wood-metals-paint-primers','painting-tools'].indexOf(handle) !== -1) {
        content.querySelectorAll('table').forEach(function (table) {
          var cells = Array.from(table.querySelectorAll('td')).filter(function (cell) { return !empty(cell); });
          if (cells.length < 2 || !cells.every(function (cell) { return cell.querySelector('img') && cell.querySelector('a[href]'); })) return;
          table.classList.add('rp-range-table');
          if (table.parentElement.classList.contains('table-wrapper')) table.parentElement.classList.add('rp-range-wrapper');
          cells.forEach(function (cell) {
            cell.classList.add('rp-range-card');
            Array.from(cell.children).forEach(function (node) {
              if (empty(node)) node.classList.add('rp-empty-spacer');
              if (node.querySelector('img')) node.classList.add('rp-range-card__image');
              if (node.classList.contains('rp-cta-row')) node.classList.add('rp-range-card__action');
              if (!node.querySelector('img') && /\$/.test(text(node))) node.classList.add('rp-range-card__price');
            });
          });
        });
      }
      /* Paint-range pages: put the existing hero copy and image into two columns. */
      if ((/^(r-|qd-|pu-)/.test(handle) || handle === 'chalky-wall-sealer-exterior-interior-sealant') && handle !== 'r-one') {
        var firstTable = content.querySelector('table');
        if (firstTable) {
          var firstCell = firstTable.querySelector('td');
          if (firstCell && firstCell.querySelector('img') && text(firstCell).length < 20) {
            var tableBlock = firstTable.closest('.table-wrapper') || firstTable;
            var lead = Array.from(content.children).slice(0, Array.from(content.children).indexOf(tableBlock));
            if (lead.length && lead.length <= 10) {
              var tableHero = document.createElement('div'); tableHero.className = 'rp-range-hero';
              var tableCopy = document.createElement('div'); tableCopy.className = 'rp-range-hero__copy';
              var tableMedia = document.createElement('div'); tableMedia.className = 'rp-range-hero__media';
              content.insertBefore(tableHero, content.firstElementChild);
              lead.forEach(function (node) { tableCopy.appendChild(node); });
              while (firstCell.firstChild) tableMedia.appendChild(firstCell.firstChild);
              firstCell.classList.add('rp-empty-spacer');
              firstTable.classList.add('rp-detail-table');
              if (tableBlock !== firstTable) tableBlock.classList.add('rp-range-wrapper');
              tableHero.appendChild(tableCopy); tableHero.appendChild(tableMedia);
            }
          }
        }
        var children = Array.from(content.children);
        var imageBlock = children.find(function (node) { return node.querySelector('img') && !node.querySelector('table') && text(node).length < 20; });
        if (imageBlock && !content.querySelector('.rp-range-hero')) {
          var preceding = children.slice(0, children.indexOf(imageBlock));
          if (preceding.length && preceding.length <= 10 && !preceding.some(function (node) { return node.querySelector('iframe,table,form'); })) {
            var hero = document.createElement('div'); hero.className = 'rp-range-hero';
            var copy = document.createElement('div'); copy.className = 'rp-range-hero__copy';
            var media = document.createElement('div'); media.className = 'rp-range-hero__media';
            content.insertBefore(hero, children[0]);
            preceding.forEach(function (node) { copy.appendChild(node); });
            media.appendChild(imageBlock); hero.appendChild(copy); hero.appendChild(media);
          }
        }
        /* A few pages embed the pack image inside the price heading. */
        if (!content.querySelector('.rp-range-hero')) {
          var inlineImage = children.slice(0, 6).find(function (node) { return node.matches('h1,h2,h3,p') && node.querySelector('img'); });
          if (inlineImage) {
            var inlineHero = document.createElement('div'); inlineHero.className = 'rp-range-hero';
            var inlineCopy = document.createElement('div'); inlineCopy.className = 'rp-range-hero__copy';
            var inlineMedia = document.createElement('div'); inlineMedia.className = 'rp-range-hero__media';
            var image = inlineImage.querySelector('img');
            var imageLink = image.closest('a');
            inlineMedia.appendChild(imageLink && text(imageLink).length === 0 ? imageLink : image);
            content.insertBefore(inlineHero, content.firstElementChild);
            children.slice(0, children.indexOf(inlineImage) + 1).forEach(function (node) { inlineCopy.appendChild(node); });
            inlineHero.appendChild(inlineCopy); inlineHero.appendChild(inlineMedia);
          }
        }
        if (!content.querySelector('.rp-range-hero')) {
          var packedLead = Array.from(content.children).find(function (node) { return node.matches('div') && node.querySelector('img') && node.querySelector('h1,h2') && text(node).length < 180; });
          if (packedLead) {
            var packedHero = document.createElement('div'); packedHero.className = 'rp-range-hero';
            var packedCopy = document.createElement('div'); packedCopy.className = 'rp-range-hero__copy';
            var packedMedia = document.createElement('div'); packedMedia.className = 'rp-range-hero__media';
            content.insertBefore(packedHero, packedLead);
            Array.from(packedLead.childNodes).forEach(function (node) { (node.nodeType === 1 && (node.matches('img') || (node.querySelector('img') && text(node).length === 0)) ? packedMedia : packedCopy).appendChild(node); });
            packedHero.appendChild(packedCopy); packedHero.appendChild(packedMedia); packedLead.remove();
          }
        }
        var rangeHero = content.querySelector('.rp-range-hero');
        var pageTitle = page && page.querySelector('.section-header__title');
        if (rangeHero && pageTitle) {
          var titleHeader = pageTitle.closest('.section-header');
          pageTitle.classList.add('rp-range-hero__title');
          rangeHero.querySelector('.rp-range-hero__copy').prepend(pageTitle);
          if (titleHeader && !text(titleHeader)) titleHeader.classList.add('rp-empty-title');
        }
        /* Layout tables are not information cards: move their original content into sections. */
        content.querySelectorAll('table.rp-detail-table').forEach(function (table) {
          var wrapper = table.closest('.table-wrapper') || table;
          var flow = document.createElement('div'); flow.className = 'rp-range-content-flow';
          wrapper.parentNode.insertBefore(flow, wrapper);
          Array.from(table.tBodies).forEach(function (body) {
            Array.from(body.rows).forEach(function (row) {
              Array.from(row.cells).forEach(function (cell) { sectionsFromNodes(Array.from(cell.childNodes), flow); });
            });
          });
          wrapper.remove();
          flow.querySelectorAll('.rp-info-section').forEach(function (section) { if (!text(section) && !section.querySelector('img,iframe,video')) section.classList.add('rp-empty-spacer'); });
        });
        /* Move long introductions out of the hero, then section the remaining copy. */
        if (rangeHero) {
          var longCopy = Array.from(rangeHero.querySelector('.rp-range-hero__copy').children).filter(function (node) { return node.matches('p,div') && text(node).length > 160; });
          longCopy.reverse().forEach(function (node) { rangeHero.after(node); });
        }
        var readingNodes = Array.from(content.childNodes).filter(function (node) {
          return !(node.nodeType === 1 && (node.classList.contains('rp-range-hero') || node.classList.contains('rp-range-content-flow') || node.classList.contains('rp-range-colour-preview')));
        });
        if (readingNodes.some(function (node) { return text(node) || (node.nodeType === 1 && node.querySelector('img,iframe,video')); })) {
          var readingFlow = document.createElement('div'); readingFlow.className = 'rp-range-content-flow';
          content.insertBefore(readingFlow, readingNodes[0]);
          sectionsFromNodes(readingNodes, readingFlow);
        }
        refineRange(content, rangeHero);
      }
    });
    root.querySelectorAll('.rp-product-description').forEach(function (description) {
      if (description.dataset.rpSectionsReady) return;
      description.dataset.rpSectionsReady = 'true';
      if (description.querySelector('table')) return; // Genuine specification tables retain their structure.
      var flow = document.createElement('div'); flow.className = 'rp-range-content-flow';
      sectionsFromNodes(Array.from(description.childNodes), flow);
      description.appendChild(flow);
      flow.querySelectorAll('.rp-info-section').forEach(function (section) {
        function promote(labelPattern, modifier, fallbackLabel) {
          if (section.classList.contains(modifier)) return;
          var heading = Array.from(section.querySelectorAll('h1,h2,h3,h4,p')).find(function (candidate) {
            return labelPattern.test(text(candidate));
          });
          if (!heading) return;
          var list = heading.nextElementSibling;
          while (list && list.matches('br,p:empty')) list = list.nextElementSibling;
          if (!list || !list.matches('ul,ol')) list = Array.from(section.querySelectorAll('ul,ol')).find(function (candidate) {
            return candidate.compareDocumentPosition(heading) & Node.DOCUMENT_POSITION_PRECEDING;
          });
          if (!list) return;
          var promoted = document.createElement('section');
          promoted.className = 'rp-info-section ' + modifier;
          var title = document.createElement('h2');
          title.className = 'rp-info-heading';
          title.textContent = text(heading) || fallbackLabel;
          promoted.appendChild(title);
          promoted.appendChild(list);
          section.parentNode.insertBefore(promoted, section);
          heading.remove();
        }
        promote(/^features?\s*:?$/i, 'rp-info-section--features rp-paint-product-features', 'Features');
        promote(/^(application(?: guide)?|how to apply)\s*:?$/i, 'rp-info-section--application rp-paint-product-application', 'Application guide');
      });
      flow.querySelectorAll('.rp-info-section').forEach(function (section) {
        section.querySelectorAll('p,div').forEach(function (block) {
          if (!text(block) && block.querySelector('img,picture') && !block.querySelector('ul,ol')) block.classList.add('rp-product-media-only');
        });
        if (!text(section) && section.querySelector('img,picture')) section.classList.add('rp-product-media-only');
        if (!text(section) && !section.querySelector('img,picture,iframe,video')) section.classList.add('rp-empty-spacer');
      });
      if (/^\/collections\/r-airpurify-color-selection-apply-rp10-for-10-off\/products\//i.test(location.pathname)) {
        description.classList.add('rp-airpurify-product-description');
        flow.querySelectorAll('.rp-info-section--application, .rp-paint-product-application').forEach(function (section) {
          // The complete, verified application guide lives on the R.AIRPURIFY
          // landing page. Remove duplicate legacy copies from every colour
          // product so they cannot repeat visually or in the accessibility tree.
          section.remove();
        });
      }
      flow.querySelectorAll('.rp-info-section--features').forEach(function (section) {
        section.classList.add('rp-paint-product-features');
        var list = Array.from(section.children).find(function (child) { return child.matches('ul,ol'); });
        if (!list || section.dataset.rpFeatureSummaryReady) return;
        section.dataset.rpFeatureSummaryReady = 'true';
        var profile = paintFeatureProfile();
        list.classList.add('rp-feature-summary-list');
        var items = Array.from(list.children).filter(function (item) { return item.matches('li'); });
        // Some legacy descriptions leave an empty Features shell after the real
        // list is promoted. Do not add a second range introduction to that shell.
        if (!items.length) {
          section.hidden = true;
          section.classList.add('rp-redundant-feature-copy');
          section.setAttribute('aria-hidden', 'true');
          return;
        }
        addFeatureIntroduction(section, profile);
        addFeatureListLabel(list);
        if (profile) items = prioritiseFeatureItems(list, items, profile.priorities);
        items.forEach(addFeaturePresentation);
        var seenFeatureTitles = {};
        var uniqueFeatures = [];
        var repeatedFeatures = [];
        items.forEach(function (item) {
          var featureTitle = text(item.querySelector('.rp-feature-title')).toLowerCase();
          if (seenFeatureTitles[featureTitle]) repeatedFeatures.push(item);
          else {
            seenFeatureTitles[featureTitle] = true;
            uniqueFeatures.push(item);
          }
        });
        items = uniqueFeatures.concat(repeatedFeatures);
        items.forEach(function (item) { list.appendChild(item); });
        if (items.length <= 6) return;
        var details = document.createElement('details');
        details.className = 'rp-feature-more';
        var summary = document.createElement('summary');
        var collapsedLabel = 'View all ' + items.length + ' features';
        summary.textContent = collapsedLabel;
        summary.setAttribute('aria-expanded', 'false');
        var remainder = document.createElement(list.tagName.toLowerCase());
        remainder.className = 'rp-feature-more__list';
        items.slice(6).forEach(function (item) { remainder.appendChild(item); });
        details.appendChild(summary);
        details.appendChild(remainder);
        section.appendChild(details);
        // Explicitly control the disclosure because the legacy theme intercepts
        // summary clicks on some product templates before the browser toggles it.
        summary.addEventListener('click', function (event) {
          event.preventDefault();
          var expanded = !details.hasAttribute('open');
          if (expanded) details.setAttribute('open', '');
          else details.removeAttribute('open');
          summary.setAttribute('aria-expanded', expanded ? 'true' : 'false');
          summary.textContent = expanded ? 'Show fewer features' : collapsedLabel;
        });
      });
    });
    root.querySelectorAll('.product-single__meta').forEach(function (meta) {
      enhanceOptionLabels(meta);
      if (meta.dataset.rpOptionsBound) return;
      meta.dataset.rpOptionsBound = 'true';
      // The existing options app mounts asynchronously. Observe only its buying panel,
      // and only child changes: no polling, colour replacement or variant interception.
      new MutationObserver(function () { enhanceOptionLabels(meta); }).observe(meta, { childList: true, subtree: true });
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { enhance(document); });
  else enhance(document);
  document.addEventListener('shopify:section:load', function () { enhance(document); });
}());
